import { render, staticRenderFns } from "./ConsignorEdit.vue?vue&type=template&id=526bcece"
import script from "./ConsignorEdit.vue?vue&type=script&lang=js"
export * from "./ConsignorEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports